module.exports = __webpack_public_path__ + "img/main@2x.dbcff6b.webp";